import { useEffect, useState } from 'react';
import { api } from '../../api';
import TileCard from '../components/TileCard';

/**
 * Open Tagging Requests — carbon copy of SignRequestsPlaceholderTile against
 * the tagging bucket. Counts come from the visibility-scoped bucket-stats
 * endpoint.
 *   Scheduled = work date assigned on the Tagging Schedule board
 *   Awaiting  = queued / not yet slotted by the Tagging Manager
 * Name keeps the "Placeholder" suffix to match its sign sibling's wiring.
 */
export default function TaggingRequestsPlaceholderTile() {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    let cancelled = false;
    api.getRequestBucketStats({ type: 'tagging_request' })
      .then(d => { if (!cancelled) setState({ loading: false, error: null, data: d }); })
      .catch(err => { if (!cancelled) setState({ loading: false, error: err?.message || 'failed', data: null }); });
    return () => { cancelled = true; };
  }, []);

  const byStatus = state.data?.by_status || {};
  const scheduled = byStatus.scheduled || 0;
  const awaiting = byStatus.submitted || 0;
  const completed = byStatus.completed || 0;

  return (
    <TileCard
      title="Open Tagging Requests"
      loading={state.loading}
      error={state.error}
      actionHref="/sales/requests/tagging_request"
      actionLabel="Tagging Requests →"
    >
      <div className="dash-stat-row" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">{scheduled}</div>
          <div className="dash-stat-chip-label">Scheduled</div>
        </div>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value" style={awaiting > 0 ? { color: '#dc2626' } : undefined}>{awaiting}</div>
          <div className="dash-stat-chip-label">Awaiting</div>
        </div>
        <div className="dash-stat-chip">
          <div className="dash-stat-chip-value">{completed}</div>
          <div className="dash-stat-chip-label">Completed</div>
        </div>
      </div>
    </TileCard>
  );
}
